import styled from 'styled-components';
import { SectionLayout } from 'components/Sections/SectionLayout';
import { Col, Row } from 'antd';

export const SectionRow = styled(Row)`
  margin-left: 0px !important;
  margin-right: 0px !important;
  padding-top: ${({ $showBreadcrumbs }) => ($showBreadcrumbs ? '60px' : '0px')};
  .hero-featured-content--bottom {
    margin-top: -175px;

    @media (max-width: 768px) {
      margin-top: -130px;
    }

    @media (max-width: 480px) {
      margin-top: -90px;
    }
  }

  @media (max-width: 1450px) {
    padding-top: 0;
  }
`;

export const SectionCol = styled(Col)`
  align-items: ${({ $contentLeftAligned }) => $contentLeftAligned && 'start !important'};
  height: 100%;

  .hero--wistia-video {
    width: 100%;
    overflow: hidden;
  }
  .hero-featured-content--center-vertically {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    .hero-featured-content--content {
      width: 100%;
    }
  }

  @media (max-width: 991px) {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }

  @media (max-width: 576px) {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-bottom: 20px;
    width: 100%;
  }

  &.hero-featured-content--col-full-bleed {
    height: 600px;
    padding-left: 0 !important;

    .hero-featured-content--content,
    .hero-featured-content--side {
      height: 100%;
      overflow: visible;
    }

    @media (max-width: 576px) {
      height: 100%;

      .hero-featured-content--content,
      .hero-featured-content--side {
        overflow: hidden;
      }
    }
  }
`;

export const StyledSectionLayout = styled(SectionLayout)`
  padding-top: 152px;
  background-image: ${({ desktopBgImage }) => desktopBgImage && `url(${desktopBgImage})`};
  background-color: ${props => props.bgColor && `var(${props.bgColor})`};
  background-size: cover;
  overflow: hidden;

  .dynamic-hero-bottom-featured-content--inner-container {
    padding-bottom: 150px;
  }

  .hero-copy {
    text-align: ${({ $contentLeftAligned }) => $contentLeftAligned && 'left'};
    max-width: 960px;

    .hero-copy-title {
      font-size: 61px;
      font-weight: 900;
      line-height: 110%;
      letter-spacing: -0.05em;
    }
    .hero-copy-title:not(:last-child) {
      margin-bottom: 0px;
    }
    .hero-copy-description {
      font-size: 20px;
      font-weight: 500;
      line-height: 150%;
      margin: 0;
      padding: 0;
      margin-top: 20px;
    }
    .hero-copy-scribe--form {
      margin-top: 40px;
    }
  }

  .ctaButton {
    margin-top: 40px;
  }

  .hero-featured-content--side {
    overflow: hidden;
  }

  @media (max-width: 1450px) {
    padding-top: 200px;
  }

  @media (max-width: 1240px) {
    padding-top: ${({ $showBreadcrumbs }) => ($showBreadcrumbs ? '140px' : '100px')};
  }

  @media (max-width: 991px) {
    .hero-copy {
      .hero-copy-title {
        font-size: 36px;
      }
      .hero-copy-description {
        font-size: 18px;
      }
    }

    .ant-form {
      input {
        padding: 17px 16px;
      }
    }
  }

  @media (max-width: 768px) {
    .hero-copy {
      .hero-copy-title {
        font-size: 32px;
      }
      .hero-copy-description {
        font-size: 17px;
        margin-bottom: 0px;
      }
      .social-proof-content {
        margin-top: 15px;
      }

      .social-proof-logo-content {
        display: flex;
        align-items: center;
        margin-top: 28px;

        .social-proof-logo-item {
          margin-right: 27px;

          &:last-child {
            margin-right: 0;
          }

          img {
            max-width: 100%;
          }
        }
      }
    }
    .dynamic-hero-bottom-featured-content--inner-container {
      padding-bottom: 130px;
    }
  }

  @media (max-width: 680px) {
    ${({ $showBreadcrumbs }) => $showBreadcrumbs && 'padding-top: 200px;'};
    .hero-copy {
      .hero-copy-title {
        font-size: 36px;
      }
      .hero-copy-description {
        font-size: 20px;
        margin-top: 21px;
      }
      .social-proof-content {
        margin-top: 15px;
      }

      .social-proof-logo-content {
        display: flex;
        align-items: center;
        margin-top: 28px;

        .social-proof-logo-item {
          margin-right: 27px;

          &:last-child {
            margin-right: 0;
          }

          img {
            max-width: 100%;
          }
        }
      }
    }

    @media (max-width: 480px) {
      background-image: ${({ desktopBgImage, mobileBgImage }) =>
        (mobileBgImage || desktopBgImage) && `url(${mobileBgImage || desktopBgImage})`};

      .dynamic-hero-bottom-featured-content--inner-container {
        padding-bottom: 70px;
      }
    }

    .ant-form {
      input {
        font-size: 18px !important;
        line-height: 23px;
        padding: 13px 11px;
        height: auto !important;
      }
      button {
        font-size: 18px;
        padding: 12px 40px;
      }
    }

    .ant-row-flex {
      flex-direction: column;
      .ant-col {
        width: 100%;
      }
    }
  }
`;

export const FeaturedContentBottom = styled.div``;

export const DemoAndSeePreviewContainer = styled.div`
  display: flex;
  align-items: ${props => (props.isInline ? 'center' : 'flex-start')};
  flex-direction: ${props => (props.isInline ? 'row' : 'column')};

  .hero-contextual-cta--origin {
    width: ${props => (props.isInline ? 'auto' : '100%')};

    @media (max-width: 576px) {
      form.ant-form-horizontal {
        margin-top: 10px !important;
      }
    }
  }

  .wistia-video--wrapper {
    .play-label {
      margin-top: ${props => (props.isInline ? '40px' : '20px')};
      margin-left: ${props => (props.isInline ? '10px' : '0')};
    }
  }
`;
